const toComma = (value) => {
    const newValue = value || 0;
    let valStr = newValue.toString();
    const numberRE = /(\d+)(\d{3})/g;
    while (numberRE.test(valStr)) {
        valStr = valStr.replace(numberRE, '$1' + ',' + '$2');
    }
    return valStr;
};
export {
    toComma,
};
